<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Megaphone Off" class="d-icon d-icon--megaphone-off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M.646.646a.5.5 0 0 1 .708 0L4.977 4.27a.512.512 0 0 1 .013.013l3.928 3.928a.508.508 0 0 1 .01.01l2.426 2.425a.5.5 0 0 1-.708.708L8.32 9.027l-2.048-.455a2.004 2.004 0 0 1-3.903-.867l-.976-.217A.5.5 0 0 1 1 7V5.5a.5.5 0 0 1 .366-.482l2.305-.64L.646 1.354a.5.5 0 0 1 0-.708ZM4.483 5.19 2 5.88v.719l5.003 1.11-2.52-2.52ZM3.349 7.923a1.005 1.005 0 0 0 1.94.43l-1.94-.43Zm7.454-5.321A.5.5 0 0 1 11 3v4.67a.5.5 0 0 1-1 0V3.658l-3.021.839a.5.5 0 0 1-.268-.964l3.655-1.015a.5.5 0 0 1 .437.084Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMegaphoneOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
